/* eslint-disable import/prefer-default-export */
import { IConfigurationState } from '.'
import { RootStore } from '../store'

export const selectConfiguration = (state: RootStore): IConfigurationState => state.configuration
